import React from 'react';
import Link from 'Components/Link';
import styles from './SiteFooter.scss';
import logoImg from './TinybopSchoolsLogo_Reversed.png';
import ContactLink from 'Components/ContactLink';
import LanguageSwitcher from 'Containers/LanguageSwitcher/LanguageSwitcher';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import ConnectedFormattedImage from 'Containers/ConnectedFormattedImage';
import { ROUTES } from 'Settings/route-strings';

const SiteFooter = () => {
  const today = new Date();
  return (
    <footer className="SiteFooter">
      <div className="SiteFooter__container">
        <div className="SiteFooter__logo">
          <ConnectedFormattedImage
            className="SiteFooter__logo-image"
            src={logoImg}
            altId="product.name"
          />
        </div>
        <div className="SiteFooter__links">
          <Link to={ROUTES.PRICING} className="SiteFooter__link">
            <ConnectedFormattedMessage id="site_footer.nav.pricing_label" />
          </Link>
          <Link to={ROUTES.PRIVACY_POLICY} className="SiteFooter__link">
            <ConnectedFormattedMessage id="site_footer.nav.privacy_label" />
          </Link>
          <Link to={ROUTES.TERMS_OF_SERVICE} className="SiteFooter__link">
            <ConnectedFormattedMessage id="site_footer.nav.terms_label" />
          </Link>
          <a
            href="https://tinybopschools.helpscoutdocs.com/"
            className="SiteFooter__link"
            target="_blank"
          >
            <ConnectedFormattedMessage id="site_footer.nav.help_label" />
          </a>
          <ContactLink extraClass="SiteFooter__link" />
        </div>
        <LanguageSwitcher />
        <p className="SiteFooter__copyright">
          <ConnectedFormattedMessage
            id="site_footer.copyright"
            values={{
              year: today.getFullYear(),
            }}
          />
        </p>
      </div>
    </footer>
  );
};

export default SiteFooter;
